<input matInput class="select-search-input select-search-hidden" />

<div class="select-search-inner" [ngClass]="{ 'select-search-inner-multiple': matSelect.multiple }">
  <input
    class="select-search-input"
    #searchSelectInput
    (keydown)="handleKeydown($event)"
    (input)="onInputChange($event.target.value)"
    (blur)="onBlur($event.target.value)"
    [placeholder]="placeholderLabel"
    autocomplete="off"
    spellcheck="false"
  />
  @if (value) {
    <button mat-icon-button aria-label="Clear" (click)="reset(true)" class="select-search-clear">
      <mat-icon class="select-search-clear-icon">close</mat-icon>
    </button>
  }
</div>
